import LegalPage from "../../components/LegalPage";

export default function MentionsLegales() {
  return (
    <LegalPage title="Mentions légales" kicker="Mentions légales">
      <h2>Éditeur du site</h2>
      <p>
        OTRAQUIZZ — informations de l&apos;éditeur à compléter (raison
        sociale, SIRET, capital social, RCS, adresse du siège).
      </p>
      <h2>Directeur de la publication</h2>
      <p>À compléter.</p>
      <h2>Hébergeur</h2>
      <p>
        Infrastructure cloud opérée par Emergent. Les informations
        détaillées de l&apos;hébergeur seront publiées avant lancement
        public.
      </p>
      <h2>Propriété intellectuelle</h2>
      <p>
        L&apos;ensemble des contenus du site (graphismes, logo,
        questions de quiz, design) sont protégés par le droit
        d&apos;auteur.
      </p>
    </LegalPage>
  );
}
